export const WEEK_DAY_OPTIONS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
].map((day) => ({ value: day, label: day }));

export function toTimeInputValue(value) {
  if (value == null || value === '') return '';
  const match = String(value).match(/(\d{2}):(\d{2})/);
  return match ? `${match[1]}:${match[2]}` : '';
}

export function toApiTime(value) {
  const hhmm = toTimeInputValue(value);
  return hhmm ? `${hhmm}:00` : '';
}

export function normalizeWeekDay(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  const match = WEEK_DAY_OPTIONS.find((day) => day.value.toLowerCase() === raw);
  return match ? match.value : String(value).trim();
}
